/**
 * Style constants
 */

const ContentStyle = {
    FRIDAY: 'friday',
    LEMATIN: 'lematin',
    LIFESTYLE: 'lifestyle',
    NOW: '20minutennow'
};

export {ContentStyle};
